import React from 'react';

const Image = ({ ...rest }) => (
    <>
        <img {...rest} loading="lazy" />
    </>
);

export default Image;